var React = require('react');

function InfoBlock (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Information"),React.createElement("path",{"d":"M30,6C16.7,6,6,16.7,6,30s10.7,24,24,24s24-10.7,24-24S43.3,6,30,6z M30,14.4c2,0,3.6,1.6,3.6,3.6S32,21.6,30,21.6\n\tS26.4,20,26.4,18S28,14.4,30,14.4z M35.6,44H24.4c-0.2,0-0.4-1.5-0.4-2c0-0.5,0.1-2,0.4-2H28V29h-3.6c-0.2-1-0.4-1.5-0.4-2\n\tc0-0.5,0.1-2,0.4-2H32v15h3.6c0.2,0,0.4,1.5,0.4,2C36,42.5,35.9,44,35.6,44z","key":1})]);
}

InfoBlock.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"60px","height":"60px","viewBox":"0 0 60 60","enableBackground":"new 0 0 60 60","xmlSpace":"preserve"};

module.exports = InfoBlock;

InfoBlock.default = InfoBlock;
